import React, { useEffect, useState } from 'react';
import { Table, Button, Modal, Form, Input, Select, Space, message } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import request from '../utils/request';

const Doctors: React.FC = () => {
  const [list, setList] = useState<any[]>([]);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [editItem, setEditItem] = useState<any>(null);
  // 新增/编辑在途锁：Modal 的 onOk 不感知 promise，必须自己置 loading 防重复提交
  const [saving, setSaving] = useState(false);
  const [departments, setDepartments] = useState<any[]>([]);
  const [stores, setStores] = useState<any[]>([]);
  const [form] = Form.useForm();

  const fetchList = async (p = page) => {
    setLoading(true);
    try {
      const res: any = await request.get('/doctor', { params: { page: p, pageSize: 10 } });
      setList(res.list);
      setTotal(res.total);
    } finally {
      setLoading(false);
    }
  };

  const fetchDepartments = async () => {
    const res: any = await request.get('/department', { params: { page: 1, pageSize: 100 } });
    setDepartments(res.list || []);
  };

  const fetchStores = async () => {
    const res: any = await request.get('/store', { params: { page: 1, pageSize: 100 } });
    setStores(res.list || []);
  };

  useEffect(() => { fetchList(); fetchDepartments(); fetchStores(); }, [page]);

  const handleSubmit = async () => {
    const values = await form.validateFields();
    if (saving) return;
    setSaving(true);
    try {
      if (editItem) {
        await request.put(`/doctor/${editItem.id}`, values);
        message.success('更新成功');
      } else {
        await request.post('/doctor', values);
        message.success('创建成功');
      }
      setModalOpen(false);
      form.resetFields();
      setEditItem(null);
      fetchList();
    } finally {
      setSaving(false);
    }
  };

  const handleDelete = async (id: number) => {
    Modal.confirm({
      title: '确认删除？',
      onOk: async () => {
        await request.delete(`/doctor/${id}`);
        message.success('删除成功');
        fetchList();
      },
    });
  };

  const columns = [
    { title: 'ID', dataIndex: 'id', width: 60 },
    { title: '姓名', dataIndex: 'name' },
    { title: '职称', dataIndex: 'title' },
    { title: '科室', dataIndex: ['department', 'name'] },
    { title: '归属门店', dataIndex: ['store', 'name'], render: (v: string) => v || '-' },
    { title: '状态', dataIndex: 'status', width: 80, render: (v: number) => v === 1 ? '启用' : '禁用' },
    {
      title: '操作', width: 150,
      render: (_: any, record: any) => (
        <Space>
          <Button size="small" onClick={() => { setEditItem(record); form.setFieldsValue(record); setModalOpen(true); }}>编辑</Button>
          <Button size="small" danger onClick={() => handleDelete(record.id)}>删除</Button>
        </Space>
      ),
    },
  ];

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 16 }}>
        <h2 style={{ margin: 0 }}>医生管理</h2>
        <Button type="primary" icon={<PlusOutlined />} onClick={() => { setEditItem(null); form.resetFields(); setModalOpen(true); }}>
          新增医生
        </Button>
      </div>
      <Table columns={columns} dataSource={list} rowKey="id" loading={loading}
        pagination={{ current: page, total, pageSize: 10, onChange: setPage }} />
      <Modal title={editItem ? '编辑医生' : '新增医生'} open={modalOpen}
        onOk={handleSubmit} onCancel={() => !saving && setModalOpen(false)}
        okButtonProps={{ loading: saving }}>
        <Form form={form} layout="vertical">
          <Form.Item name="name" label="姓名" rules={[{ required: true }]}>
            <Input />
          </Form.Item>
          <Form.Item name="title" label="职称">
            <Input placeholder="如：主任医师、副主任医师" />
          </Form.Item>
          <Form.Item name="departmentId" label="所属科室" rules={[{ required: true }]}>
            <Select options={departments.map((d) => ({ label: d.name, value: d.id }))} />
          </Form.Item>
          <Form.Item name="storeId" label="归属门店">
            <Select allowClear placeholder="不选则不展示在门店页"
              options={stores.map((s) => ({ label: s.name, value: s.id }))} />
          </Form.Item>
          <Form.Item name="description" label="简介">
            <Input.TextArea rows={3} />
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};

export default Doctors;
